/**
 * Photos de profil : règles d'affichage pures, sans réseau ni état. L'école tient un annuaire
 * (identifiant → adresse versionnée de la photo) ; seuls les élèves et les moniteurs qui ont une
 * photo y figurent, les autres gardent leurs initiales.
 */
export type PhotoDirectory = {
  /** Élèves, par identifiant de fiche élève. */
  candidates: Record<string, string>;
  /** Comptes de l'équipe (messagerie, en-tête), par identifiant de compte. */
  staff: Record<string, string>;
  /** Moniteurs du planning, par identifiant de planning. */
  instructors: Record<string, string>;
};

export const EMPTY_PHOTOS: PhotoDirectory = { candidates: {}, staff: {}, instructors: {} };

const addresses = (value: unknown): Record<string, string> =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? Object.fromEntries(
        Object.entries(value).filter(
          (entry): entry is [string, string] =>
            typeof entry[1] === 'string' && entry[1].startsWith('/v1/'),
        ),
      )
    : {};

/** Annuaire tel que reçu ; une réponse inattendue vaut un annuaire vide (initiales partout). */
export function photoDirectory(data: unknown): PhotoDirectory {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return EMPTY_PHOTOS;
  const raw = data as Partial<Record<keyof PhotoDirectory, unknown>>;
  return {
    candidates: addresses(raw.candidates),
    staff: addresses(raw.staff),
    instructors: addresses(raw.instructors),
  };
}
